import NotesReferral from "../components/NotesReferral";
import NavigationBar from "../components/NavigationBar";
import Footer from "../components/Footer";
function ReferralNotePage() {
	return (
		<>
			<NavigationBar />
			<NotesReferral />
			<Footer />
		</>
	);
}

export default ReferralNotePage;
